import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const CaseTitlesField = ({ limitSelectOptions, disabled }) => {
  return (
    <Field name="case_titles" parse={({ value }) => value}>
      {({ input }) => (
        <Fragment>
          <label>Case Titles</label>
          <Select
            {...input}
            clearable={false}
            options={limitSelectOptions}
            className="form-select"
            disabled={disabled}
          />
        </Fragment>
      )}
    </Field>
  );
};

CaseTitlesField.propTypes = {
  limitSelectOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

CaseTitlesField.defaultProps = {
  disabled: false,
};

export default CaseTitlesField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/CaseTitlesField.jsx